module.exports = __webpack_public_path__ + "img/img37.8fee9539.svg";